export default {
  toasts: {
    load_error: 'Impossibile caricare le tariffe delle commissioni',
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate',
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  rates: {
    title: 'Margine di elaborazione',
    description:
      'Percentuale in %, più un importo fisso e un importo minimo facoltativi per addebito. «Qualsiasi metodo di pagamento» si applica quando non esiste una tariffa specifica per il metodo.',
    default: {
      inherits:
        'Nessuna tariffa Adyen impostata: i ristoranti di questo partner su Adyen di FoodAmigos pagano la tariffa predefinita di FoodAmigos riportata sotto. Una tariffa impostata qui la sostituisce; una tariffa impostata su un singolo ristorante ha comunque la precedenza.',
      overridden:
        'La tariffa Adyen propria di questo partner sostituisce la tariffa predefinita di FoodAmigos riportata sotto per i suoi ristoranti su Adyen di FoodAmigos. Rimuovila per tornare alla tariffa predefinita.',
      own_adyen:
        'Questo partner elabora i pagamenti con il proprio account Adyen. I suoi ristoranti non pagano commissioni di elaborazione a meno che qui o su un singolo ristorante non sia impostata una tariffa.',
      master:
        'Queste sono le tariffe predefinite di FoodAmigos. Ogni partner su Adyen di FoodAmigos senza una tariffa Adyen propria le utilizza.',
      rows_title: 'Tariffe predefinite di FoodAmigos',
    },
  },
};
